import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChromecast: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconChromecast"><Path d="M2.75 13.75C6.33985 13.75 9.25 16.6601 9.25 20.25M2.75 9.75C8.54899 9.75 13.25 14.451 13.25 20.25M16.75 20.25H18.25C19.9069 20.25 21.25 18.9069 21.25 17.25V6.75C21.25 5.09315 19.9069 3.75 18.25 3.75H5.25C3.86929 3.75 2.75 4.86929 2.75 6.25M2.75 17.75C4.13071 17.75 5.25 18.8693 5.25 20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconChromecast;
